<template>
  <div>
    <div class="banner-formula-two">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="banner-content">
              <div class="row">
                <div class="col-lg-4">
                  <div class="banner-carousel text-center">
                    <carousel :autoplay=true :items=1 :nav="false" class="banner-formula-two-slider">
                      <div class="d-block">
                        <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/1+.png" alt="">
                      </div>
                      <div class="d-block">
                        <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/2+.png" alt="">
                      </div>
                      <div class="d-block">
                        <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/3+.png" alt="">
                      </div>
                      <div class="d-block">
                        <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/1+pachet.png" alt="">
                      </div>
                      <div class="d-block">
                        <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/2+pachet.png" alt="">
                      </div>
                      <div class="d-block">
                        <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/1.png" alt="">
                      </div>
                      <div class="d-block">
                        <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/2.png" alt="">
                      </div>
                      <div class="d-block">
                        <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/1pachet.png" alt="">
                      </div>
                      <div class="d-block">
                        <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/2pachet.png" alt="">
                      </div>
                    </carousel>
                  </div>
                </div>
                <div class="col-lg-8">
                  <div class="heading1">Descoperă formulele <h1>Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup></h1></div>
                  <p class="d-none d-lg-block">Inspirată de 50 de ani de cercetare avansată a laptelui matern, <strong>Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup></strong> Formula pentru copii de vârstă mică este <strong>special
                    conceput să susțină sistemul imunitar¹ al copilului tău</strong>, datorită imuno-nutrienților prezenți în mod natural și în laptele matern¹.</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'

export default {
  components: {carousel},
  props: ['mobile_component'],
  data() {
    return {}
  },
  methods: {
    goTo() {
      window.fbq('track', 'Comanda-Acum');
      window.gtag('event', 'click', {'event_category': 'buton-cumpara-acum'});
      window.open("https://www.emag.ro/lapte-praf-bebelusi/brand/nutricia/c?ref=bc&utm_source=aptanutricia&utm_medium=click_product&utm_campaign=campanie-ctbm&utm_content=buton_cumpara_acum", '_blank');
    }
  }
}
</script>

<style lang="scss">
.img-fluid pack {
  max-width: 583px;
}

.banner-formula-two {
  background: #DFF1FD url("../../assets/images/formule-aptamil/formula-banner-bg.jpg") no-repeat center;
  background-size: cover;

  .banner-carousel {
    margin-top: -150px;
  }

  .banner-content {
    padding: 40px;
    margin-top: 390px;
    background: rgba(255, 255, 255, .9);

    .heading1 {
      font-family: 'Montserrat', sans-serif;
      color: #001489;
      font-size: 40px;
      font-weight: 700;
      padding-right: 10%;
      line-height: 1.2;

      h1 {
        color: #001489;
        font-size: 40px;
        font-weight: 700;
        line-height: 1.2;
      }
    }

    p {
      font-family: 'Montserrat', sans-serif;
      color: #001489;
      font-size: 21px;
    }
  }

  .btn-cumpara {
    background: #17479E;
    width: 260px;
    text-transform: none;
    margin-top: 30px;
  }
}

.banner-formula-two-slider {
  .owl-carousel .owl-item img.img-produs {
    width: 100% !important;
    object-fit: contain;
  }
}

@media screen and (max-width: 992px) {
  .banner-formula-two {
    .banner-content {
      text-align: center;

      .heading1 {
        margin-top: 30px;
        padding-right: 0;
        font-size: 23px;
        line-height: 1;

        h1 {
          font-size: 23px;
          line-height: 1;
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .banner-formula-two {
    background: #DFF1FD url("../../assets/images/formule-aptamil/formula-banner-bg-mobile.jpg") no-repeat top center;
    background-size: 100%;
  }
}

@media screen and (max-width: 768px) {
  .banner-formula-two-slider {
    margin: 0 auto;
    width: 75%;
  }

  .banner-formula-two .banner-content {
    margin-top: 340px;
  }

  .banner-formula-two .banner-content .heading1 {
    margin-top: 15px;
  }
}
</style>
